type Variant = "footer" | "inline" | "boxed" | "article";

interface Props {
  variant?: Variant;
  className?: string;
}

const STATEMENT_1 =
  "The content on this website is provided for general educational and informational purposes only and is not medical advice or a substitute for individualized psychiatric or medical care.";

const STATEMENT_2 =
  "Viewing this website, reading its content, or submitting information through the website does not establish a physician-patient relationship.";

export function EducationalDisclaimer({ variant = "inline", className = "" }: Props) {
  if (variant === "footer") {
    return (
      <div className={className}>
        <p className="text-sm text-gray-300 leading-relaxed font-light">
          {STATEMENT_1}
        </p>
        <p className="text-sm text-gray-300 leading-relaxed font-light mt-3">
          {STATEMENT_2}
        </p>
        <p className="text-sm text-gray-300 leading-relaxed font-light mt-3">
          If you are in crisis or feel unsafe, call or text 988 in the United States, call 911, or go to the nearest emergency room.
        </p>
      </div>
    );
  }

  if (variant === "boxed") {
    return (
      <div className={className}>
        <p className="text-sm font-light text-secondary leading-relaxed">
          {STATEMENT_1}
        </p>
        <p className="text-sm font-light text-secondary leading-relaxed mt-3">
          {STATEMENT_2}
        </p>
      </div>
    );
  }

  if (variant === "article") {
    return (
      <aside
        role="note"
        aria-label="Educational disclaimer"
        className={`mt-12 border border-border bg-muted/40 p-6 text-sm text-secondary font-light leading-relaxed ${className}`}
      >
        <strong className="font-medium text-primary block mb-2">Educational Disclaimer</strong>
        <p>{STATEMENT_1}</p>
        <p className="mt-2">{STATEMENT_2}</p>
      </aside>
    );
  }

  return (
    <div className={className}>
      <p className="text-base text-secondary font-light leading-relaxed">
        {STATEMENT_1}
      </p>
      <p className="text-base text-secondary font-light leading-relaxed mt-3">
        {STATEMENT_2}
      </p>
    </div>
  );
}
